import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ContactReasonsAPI from '../../api/contactReasons';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getContactReasons(_state) {
    return _state.records;
  },
  getActiveReasons(_state) {
    return _state.records.filter(r => r.active);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getContactReasons({ commit }) {
    commit(types.SET_CONTACT_REASON_UI_FLAG, { isFetching: true });
    try {
      const response = await ContactReasonsAPI.get();
      const data = response.data.data || response.data;
      commit(types.SET_CONTACT_REASONS, data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CONTACT_REASON_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createContactReason({ commit }, reasonObj) {
    commit(types.SET_CONTACT_REASON_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactReasonsAPI.create(reasonObj);
      const data = response.data.data || response.data;
      commit(types.ADD_CONTACT_REASON, data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CONTACT_REASON_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateContactReason({ commit }, { id, ...updateObj }) {
    commit(types.SET_CONTACT_REASON_UI_FLAG, { isUpdating: true });
    try {
      const response = await ContactReasonsAPI.update(id, updateObj);
      const data = response.data.data || response.data;
      commit(types.EDIT_CONTACT_REASON, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_REASON_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteContactReason({ commit }, id) {
    commit(types.SET_CONTACT_REASON_UI_FLAG, { isDeleting: true });
    try {
      await ContactReasonsAPI.delete(id);
      commit(types.DELETE_CONTACT_REASON, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_REASON_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_REASON_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_CONTACT_REASONS]: MutationHelpers.set,
  [types.ADD_CONTACT_REASON]: MutationHelpers.create,
  [types.EDIT_CONTACT_REASON]: MutationHelpers.update,
  [types.DELETE_CONTACT_REASON]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
